import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../Homepage/Navbar';
import Footer from '../Homepage/Footer';
import { Base_URL, imageBaseURL } from '../../actions/API_endpoint';

const BlogDetail = () => {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const response = await axios.get(`${Base_URL}/api/blogs/${slug}`);
                if (response.data.success) {
                    setBlog(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching blog:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBlog();
    }, [slug]);

    if (loading) {
        return (
            <div className="min-h-screen flex flex-col bg-dark-secondary">
                <Navbar />
                <main className="flex-grow flex items-center justify-center">
                    <div className="text-white text-xl">Loading...</div>
                </main>
                <Footer />
            </div>
        );
    }

    if (!blog) {
        return (
            <div className="min-h-screen flex flex-col bg-dark-secondary">
                <Navbar />
                <main className="flex-grow flex items-center justify-center">
                    <div className="text-white text-xl">Blog not found.</div>
                </main>
                <Footer />
            </div>
        );
    }

    return (
        <div className="min-h-screen flex flex-col bg-dark-secondary">
            <Navbar />
            <main className="flex-grow pt-32 pb-20">
                <div className="container mx-auto px-4 max-w-4xl">
                    <Link to="/blog" className="text-accent-primary hover:text-accent-hover mb-6 inline-block font-semibold">
                        &larr; Back to Blogs
                    </Link>

                    <article className="bg-dark-tertiary rounded-2xl shadow-xl overflow-hidden border border-white/5">
                        {blog.image_url && (
                            <img
                                src={`${imageBaseURL}${blog.image_url}`}
                                alt={blog.title}
                                className="w-full h-64 md:h-96 object-cover"
                            />
                        )}
                        <div className="p-8 md:p-12">
                            <h1 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
                                {blog.title}
                            </h1>
                            <div className="flex items-center text-gray-400 mb-8 text-sm">
                                <span>By <span className="text-nvcti-orange">{blog.author}</span></span>
                                <span className="mx-2">•</span>
                                <span>{new Date(blog.created_at).toLocaleDateString()}</span>
                            </div>
                            <div className="prose prose-lg prose-invert max-w-none text-gray-300">
                                {blog.content.split('\n').map((paragraph, idx) => (
                                    <p key={idx} className="mb-4">{paragraph}</p>
                                ))}
                            </div>
                        </div>
                    </article>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default BlogDetail;
